import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router} from '@angular/router';
import {Auth} from './auth.service';

@Injectable()
export class RoleGuard implements CanActivate {

    constructor(private auth: Auth, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot) {
        if (!this.auth.isLoggedIn()) {
            const next = this.router['location'].path();
            this.router.navigate(['/belepes'], {queryParams: {n: next}});
            return false;
        }

        if (!this.auth.hasAnyRoleOf(...(route.data['allowed'] || []))) {
            const next = this.router['location'].path();
            this.router.onSameUrlNavigation = 'reload';
            this.router.navigate(['/jogosulatlan'], {queryParams: {n: next}});
            return false;
        }

        return true;
    }
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/auth/role-guard.service.ts